import { Context } from '@alltrails/shared/types/context';
import ApplicationLayout from 'components/ApplicationLayout';
import CustomProvider from 'components/CustomProvider';
import ForgotPasswordForm from 'components/forms/ForgotPasswordForm/ForgotPasswordForm';
import * as styles from './ForgotPassword.module.scss';

type Props = {
  context: Context;
  currentPage: string;
  locationSlug: string;
  forgotPasswordUrl: string;
  resourceName: string;
};

export default function ForgotPassword({ context, currentPage, locationSlug, forgotPasswordUrl, resourceName }: Props) {
  return (
    <CustomProvider>
      <ApplicationLayout context={context} currentPage={currentPage} locationSlug={locationSlug}>
        <div className={styles.content}>
          <ForgotPasswordForm forgotPasswordUrl={forgotPasswordUrl} resourceName={resourceName} />
        </div>
      </ApplicationLayout>
    </CustomProvider>
  );
}
